<template>
    <div>
        <DefaultMenu>
            <template #title>
                Declaraciones
            </template>
     
            <b-button
                v-permission="'pep-menu-crear'"
                v-b-modal.createModalPep
            >
                Crear <b-icon icon="journal-check" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'pep-menu-notificaciones'"
                v-b-modal.notificacionesModalStatementPep
                class="ms-1"
            >
                Notificaciones procesadas <b-icon icon="mailbox" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'pep-menu-notificaciones'"
                v-b-modal.notificacionesModalAssignmentStatementPep
                class="ms-1"
            >
                Plantillas asignadas <b-icon icon="people" font-scale="1"></b-icon>
            </b-button>
            
            <template #right>
                <b-button
                    v-permission="'pep-reportes'"
                    v-b-modal.reportModalStatementPep
                    class="me-2"
                >
                    <b-icon icon="file-earmark-pdf" font-scale="1"></b-icon>
                </b-button>

                <b-button
                    v-permission="'pep-configuracion'"
                    @click="modalShowSetting = true"
                    title="Configuración"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="gear"/>
                </b-button>
            </template>
        </DefaultMenu>
        
        <BaseModal v-model="modalShowSetting" size="xl">
            <StatementSetting></StatementSetting>
        </BaseModal>

        <!-- Modal -->
        <b-modal
            v-model="modalShowCreate"
            hide-footer
            id="createModalPep"
            title="Crear una declaración"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
            class="m-0 p-0"
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>
            </template>
            <StatementCreate></StatementCreate>
        </b-modal>

        <b-modal
            v-model="modalShowNotifications"
            hide-footer
            id="notificacionesModalStatementPep"
            title="Notificaciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>

            </template>

            <StatementNotificationList></StatementNotificationList>

        </b-modal>

        <b-modal
            v-model="modalShowAssignmentNotifications"
            hide-footer
            id="notificacionesModalAssignmentStatementPep"
            title="Notificaciones Asignaciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>

            </template>

            <StatementNotificationAssignmentList></StatementNotificationAssignmentList>

        </b-modal>

        <b-modal
            v-model="modalShowReport"
            hide-footer
            id="reportModalStatementPep"
            title="Reporte de Declaraciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>
            </template>
            <StatementReport></StatementReport>
        </b-modal>
    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import BaseModal from '@/components/shared/Base-modal.vue'
import StatementNotificationList from "@/components/PepStatements/PepStatementMenu/Pep-statement-notification-list.vue";
import StatementCreate from "@/components/PepStatements/PepStatementMenu/Pep-statement-create.vue";
import StatementSetting from "@/components/PepStatements/PepStatementMenu/Pep-statement-setting.vue";
import StatementReport from "./Pep-statement-report.vue";
import StatementNotificationAssignmentList from "@/components/PepStatements/PepStatementMenu/Pep-statement-notification-assignment-list.vue";

export default {
    name: 'StatementsMenu',
    
    components: {
        StatementNotificationList,
        StatementCreate,
        DefaultMenu,
        StatementSetting,
        BaseModal,
        StatementReport,
        StatementNotificationAssignmentList
    },

    data() {
        return {
            modalShowCreate: false,
            modalShowNotifications: false,
            modalShowSetting: false,
            modalShowReport: false,
            modalShowAssignmentNotifications: false
        }
    },
}
</script>